<template>
  <div>
    <p><strong>Предмет:</strong> {{ type.subject }}, {{ type.format }}</p>
    <p><strong>Занятия:</strong>
      <span class="billing__day" v-for="day in subscribe.days">{{ day.day }} {{ day.time }}</span>
    </p>
    <p><strong>Остаток занятий:</strong> {{ remainder }}</p>
    <p><strong>Остаток отработок (за квартал):</strong> 3</p>
    <button class="uk-button uk-button-primary" @click="$emit('onBuyPacket', 'buy_packet')">Купить пакет занятий</button>
  </div>
</template>

<script>
export default {
  name: "info",
  data() {
    return {}
  },
  computed: {
    type() {
      return this.subscribe.subscribe_type;
    }
  },
  props: {
    subscribe: '',
    remainder: ''
  },
  methods: {}
}
</script>